export default "__VITE_ASSET__CcZ95HS8__"